const toPositiveNumber = (value, fallback) => {
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
}

const playConfig = {
  scoreTickSeconds: toPositiveNumber(process.env.VUE_APP_PLAY_SCORE_TICK_SECONDS, 2),
  speedRampDivisor: toPositiveNumber(process.env.VUE_APP_PLAY_SPEED_RAMP_DIVISOR, 50000),
  malusBlockSeconds: toPositiveNumber(process.env.VUE_APP_PLAY_MALUS_BLOCK_SECONDS, 1),
  gameOverFlashDelayMs: toPositiveNumber(process.env.VUE_APP_PLAY_GAME_OVER_FLASH_DELAY_MS, 800),
  gameOverScreenDelayMs: toPositiveNumber(process.env.VUE_APP_PLAY_GAME_OVER_SCREEN_DELAY_MS, 1000),
  moveListenerDelayMs: toPositiveNumber(process.env.VUE_APP_PLAY_MOVE_LISTENER_DELAY_MS, 1000)
}

export default playConfig
